export const constants = {
  defaultMeetingDurationInMinutes: 60,
  defaultMeetingIntervalInMinutes: 30,

  dateFormat: "dd.MM.yyyy",
  timeFormat: "HH:mm",

  minimalContrastRatio: 5,
  shorthandColorRegExp: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
};

export const validation = {
  // eslint-disable-next-line
  emailRegExp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phoneNumberRegExp: /^(\(?\+?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(\s?)+$/,
  // eslint-disable-next-line
  cityNameRegExp: /^[^!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]+$/,
};
